module.exports = __webpack_public_path__ + "static/img/Deyuimg_01.c63ca608.png";